import { render } from "./UsuariosRegistro.vue?vue&type=template&id=a1ea607c"
import script from "./UsuariosRegistro.vue?vue&type=script&lang=js"
export * from "./UsuariosRegistro.vue?vue&type=script&lang=js"

import exportComponent from "/github/workspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__